// extracted by mini-css-extract-plugin
export default {"overview-content-skeleton__container":"styles_overview-content-skeleton__container__aEeEx"};